import React from "react";
import DialogPopup from "@_components/DialogPopup/DialogPopup";
import Button from "@mui/material/Button";
import { useDispatch, useSelector } from "react-redux";
import { caseActions } from "@_actions/case.actions";
import {
  formatDatetime,
  getCurrencySign,
  isDateBeforeToday,
  stateError,
} from "@_utils/helpers";
import styles from "./ActivateCasePopup.module.css";
import NoImage from "@_assets/images/noimage.png";
import Scrollbar from "react-perfect-scrollbar-z";
import "scrollbar.css";
import { caseConstants } from "@_constants/case.constants";
import TaxTypes from "@_configs/TaxType.config";
import { LicenseConstants } from "@_constants/license.constants";

function ActivateCasePopup(props) {
  const { data, caseId } = props;
  const caseReducer = useSelector((state) => {
    return state.caseReducer;
  });
  const dispatch = useDispatch();
  const selectedTax =
    TaxTypes.find((tax) => tax.id === data.charge_details?.indirect_tax_type)
      ?.label || "";

  const isDiscountDeadlinePast = isDateBeforeToday(
    data.charge_details?.settlement_offer?.settlement_date,
  );
  const errorMessage = isDiscountDeadlinePast
    ? caseConstants.CASE_ACTIVATE_DISCOUNT_DEADLINE_PAST_ERROR
    : stateError(caseReducer.status.CASE_UPDATE_STATE_ACTIVATE);

  const actionClicked = () => {
    if (isDiscountDeadlinePast) return;
    dispatch(caseActions.updateCaseStateActivate(caseId));
  };

  const closePopup = () => {
    dispatch(caseActions.clearStateMessage("CASE_UPDATE_STATE_ACTIVATE"));
    props.close();
  };

  return (
    <DialogPopup
      onKeyUp={(e) => {
        if (e.key === "Enter") {
          actionClicked();
        }
      }}
      title="Activate Case"
      open={props.open}
      onClose={() => props.close()}
    >
      <Scrollbar maxHeight={"calc(100vh - 174px)"}>
        <div className={styles.content_container}>
          <div className={styles.findings_container}>
            {data.findings &&
              data.findings.map((finding, index) => (
                <div key={index}>
                  {finding.license &&
                  finding.license.state === LicenseConstants.STATE_VALID ? (
                    <></>
                  ) : (
                    <div className={styles.finding_container} key={index}>
                      <div className={styles.finging_image_container}>
                        <img
                          className={styles.finging_image}
                          src={
                            finding.original_image.original_image_url || NoImage
                          }
                          alt={"Finding result"}
                        />
                      </div>
                      <div className={styles.finging_details_container}>
                        <p className={styles.finding_id}>
                          {finding.original_image.filename}
                        </p>
                      </div>
                      <div className={styles.finging_price_container}>
                        <div className={styles.price_label}>License Fee</div>
                        <div className={styles.price_value}>
                          {getCurrencySign(data.claim_details.currency)}{" "}
                          {finding.price}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
          </div>
          <div className={styles.total_container}>
            <div className={styles.total_label}>Net License fee</div>
            <div className={styles.total_value}>
              {getCurrencySign(data.claim_details.currency)}{" "}
              {data.charge_details.total_net_amount_findings}
            </div>
          </div>

          {data.charge_details.additional_fees_no_settlement &&
            data.charge_details.additional_fees_no_settlement.map(
              (fee, index) => (
                <div className={styles.price_row} key={index}>
                  <div key={1} className={styles.price_container}>
                    <div className={styles.price_label}>Name</div>
                    <div className={styles.price_value}>{fee.name}</div>
                  </div>
                  <div key={2} className={styles.price_container}>
                    <div className={styles.price_label}>Percentage</div>
                    <div className={styles.price_value}>{fee.percentage} %</div>
                  </div>
                  <div key={3} className={styles.price_container}>
                    <div className={styles.price_label}>Additional Fee</div>
                    <div className={styles.price_value}>
                      {getCurrencySign(data.claim_details.currency)}{" "}
                      {fee.amount}
                    </div>
                  </div>
                  <br />
                </div>
              ),
            )}
          <hr className={styles.activate_hr} />
          <div className={styles.price_row}>
            <div key={4} className={styles.price_container}>
              {data.charge_details?.indirect_tax_type ===
                caseConstants.CASE_TAX_TYPE_NO_INDIRECT_TAX ||
              data.charge_details?.indirect_tax_type ===
                caseConstants.CASE_TAX_TYPE_REVERSE_CHARGE ? (
                <div className={styles.price_label}>
                  {data.charge_details?.indirect_tax_type ===
                  caseConstants.CASE_TAX_TYPE_NO_INDIRECT_TAX
                    ? "No Indirect Tax"
                    : "Reverse Charge"}
                </div>
              ) : (
                <>
                  <div className={styles.price_label}>{selectedTax}</div>
                  <div className={styles.price_value}>
                    {(data.charge_details.indirect_tax_settlement &&
                      data.charge_details.indirect_tax_settlement.percentage) ||
                      (data.charge_details.indirect_tax_no_settlement &&
                        data.charge_details.indirect_tax_no_settlement
                          .percentage)}{" "}
                    %
                  </div>
                </>
              )}
            </div>
            <div key={5} className={styles.price_container}>
              <div className={styles.price_label}>Claim Opponent Country</div>
              <div className={styles.price_value}>{data.country}</div>
            </div>
            <div key={6} className={styles.price_container}>
              {data.charge_details?.indirect_tax_type !==
                caseConstants.CASE_TAX_TYPE_NO_INDIRECT_TAX &&
                data.charge_details?.indirect_tax_type !==
                  caseConstants.CASE_TAX_TYPE_REVERSE_CHARGE && (
                  <>
                    {" "}
                    <div className={styles.price_label}>
                      {selectedTax} Amount
                    </div>
                    <div className={styles.price_value}>
                      {getCurrencySign(data.claim_details.currency)}{" "}
                      {(data.charge_details.indirect_tax_settlement &&
                        data.charge_details.indirect_tax_settlement.amount) ||
                        (data.charge_details.indirect_tax_no_settlement &&
                          data.charge_details.indirect_tax_no_settlement
                            .amount)}
                    </div>
                  </>
                )}
            </div>
          </div>
          <hr className={styles.activate_hr} />
          <div className={styles.price_row}>
            <div key={7} className={styles.price_container}>
              <div className={styles.price_label}>Discount</div>
              <div className={styles.price_value}>
                {(data.charge_details.settlement_offer &&
                  data.charge_details.settlement_offer.settlement_percentage) ||
                  "--"}{" "}
                %
              </div>
            </div>
            <div key={8} className={styles.price_container}>
              <div className={styles.price_label}>Discount Deadline</div>
              <div className={styles.price_value}>
                {data.charge_details.settlement_offer &&
                  formatDatetime(
                    data.charge_details.settlement_offer.settlement_date,
                    "short",
                  )}{" "}
              </div>
            </div>
          </div>

          <div className={styles.total_container}>
            <div className={styles.total_label}>
              Gross incl.
              {data.charge_details?.indirect_tax_type !==
                caseConstants.CASE_TAX_TYPE_NO_INDIRECT_TAX &&
                data.charge_details?.indirect_tax_type !==
                  caseConstants.CASE_TAX_TYPE_REVERSE_CHARGE &&
                selectedTax + " & "}
              Fees
            </div>
            <div className={styles.total_value}>
              {getCurrencySign(data.claim_details.currency)}{" "}
              {data.charge_details.final_amount_gross_no_settlement}
            </div>
            <br />
            {data.charge_details.final_amount_gross_settlement && (
              <>
                <div className={styles.total_label}>
                  Discounted gross incl.
                  {data.charge_details.indirect_tax_type !==
                    "NO_INDIRECT_TAX" && selectedTax + " & "}
                  Fees
                </div>

                <div className={styles.total_value}>
                  {getCurrencySign(data.claim_details.currency)}{" "}
                  {data.charge_details.final_amount_gross_settlement || "--"}
                </div>
              </>
            )}
          </div>
        </div>
      </Scrollbar>
      {errorMessage && (
        <div
          className={styles.error_container}
          data-testid="activate-case-error"
        >
          <div className={styles.error_text}>{errorMessage}</div>
        </div>
      )}

      <div className="action_container">
        <Button
          data-testid="activate-case-cancel-btn"
          className="btn_cancel"
          onClick={closePopup}
        >
          Cancel
        </Button>
        <Button
          data-testid="activate-case-confirm-btn"
          className="btn_confirm"
          onClick={actionClicked}
          disabled={isDiscountDeadlinePast}
        >
          Activate Case
        </Button>
      </div>
    </DialogPopup>
  );
}

export default ActivateCasePopup;
